import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { AgentStatIndicator } from '../models/agent-stat.model';
import { AgentStatsService } from '../services/agent-stats.service';
import { bcEnums } from 'common/common/constants/boldchat-enums';
import { Subscription } from 'rxjs';
import { StatService } from '../services/agent-stat.service';
import { AgentStatObject } from '../agent-stat-object';
import { CompareToType } from '../agent-stat-enums';

@Component({
  selector: 'app-detailed-agent-stat',
  templateUrl: './detailed-agent-stat.component.html',
  styleUrls: ['./detailed-agent-stat.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DetailedAgentStatComponent implements OnInit, OnDestroy {
  @Input()
  indicator: AgentStatIndicator;

  public indicatorTitle: string;
  public indicatorUnit: string;
  public indicatorSubtitle: string;
  public indicatorPostFix: string;
  public isOverPerform: boolean = false;

  private _init: AgentStatObject;
  private _triggersSubscription: Subscription;
  private _targetValue: number;
  private _currentValue: number;
  private _indicatorWithoutOrderId;

  constructor(private _agentStatService: AgentStatsService,
              private _statService: StatService,
              private _changeDetectorRef: ChangeDetectorRef) {
  }

  async ngOnInit() {
    this._indicatorWithoutOrderId = {...this.indicator};
    delete this._indicatorWithoutOrderId.orderId;

    if (this.indicator.serviceType === bcEnums.services.CHATS) {
      this._init = await this._statService.initStat(this._indicatorWithoutOrderId);
      if (this._init) {
        this._triggersSubscription = this._init.newStatValue$.subscribe((newValues) => {
          this._currentValue = newValues.agentPerformanceValueToBeCompared;

          if (this.indicator.compareToType !== CompareToType.NONE) {
            if (+this.indicator.compareToValue > 0) {
              this._targetValue = parseInt(this.indicator.compareToValue, 10);
            } else if (+this.indicator.compareToDuration > 0) {
              this._targetValue = newValues.agentPerformanceValueToCompare;
            }
          }
          this._changeDetectorRef.detectChanges();
          this._handleOverPerform();
        });
      }
    }
    this._getTextsBasedOnIndicatorType();
  }

  ngOnDestroy(): void {
    if (this._triggersSubscription) {
      this._triggersSubscription.unsubscribe();
      this._triggersSubscription = null;
    }
    if (this._init) {
      this._init.cleanUp();
      this._init = null;
    }
  }

  public getCurrentValue(): number {
    return this._currentValue;
  }

  public getCompareToDuration() {
    return this._agentStatService.getCompareToDuration(this.indicator.compareToDuration);
  }

  public getPerformancePercentage(): number {
    if (this.indicator.compareToValue) {
      return this._agentStatService.getPerformancePercentage(parseInt(this.indicator.compareToValue, 10), this._currentValue);
    }
    return this._agentStatService.getPerformancePercentage(this._targetValue, this._currentValue);
  }

  public getTargetValue(): number {
    if (this.indicator.compareToValue) {
      return parseInt(this.indicator.compareToValue, 10);
    }
    return this._targetValue;
  }

  public isComparison(): boolean {
    return this._agentStatService.isComparison(this.indicator);
  }

  public getIndicatorDuration(): string {
    return this._agentStatService.getDuration(this.indicator.indicatorDuration);
  }

  private _getTextsBasedOnIndicatorType(): void {
    const texts = this._agentStatService.getTextsBasedOnIndicatorType(this.indicator.indicatorType);
    if (texts) {
      this.indicatorTitle = texts.title;
      this.indicatorUnit = texts.unit ? texts.unit : '';
      this.indicatorSubtitle = texts.subtitle ? texts.subtitle : '';
      this.indicatorPostFix = texts.targetPostFix ? texts.targetPostFix : '';
    }
  }

  private _handleOverPerform(): void {
    if (this.isComparison()) {
      this.isOverPerform = this._agentStatService.isOverPerform(this.getPerformancePercentage());
    }
  }
}
